import { filterTypes } from '@/model/innovation-field/filter'

export default {
    [filterTypes.INNOVATION_PROJECTS]: 'Innovation project',
    [filterTypes.TRENDRADARS]: 'Trend radar'
}
